'use strict';

var gettext = require('mag-gettext').gettext,
    data = [
        {value: 'Auto', name: gettext('Auto')},
        {value: 'PAL', name: 'PAL (576i)'},
        {value: '576p-50', name: '576p-50'},
        {value: '720p-50', name: '720p-50'},
        {value: '1080i-50', name: '1080i-50'},
        {value: '1080p-50', name: '1080p-50'},
        {value: 'NTSC', name: 'NTSC (480i)'},
        {value: '720p-60', name: '720p-60'},
        {value: '1080i-60', name: '1080i-60'},
        {value: '1080p-60', name: '1080p-60'}
    ];


switch ( core.device.model ) {
    case 'MAG250':
        // supported video modes
        // { value: 'PAL', name: 'PAL (576i)' },
        // { value: '576p-50', name: '576p-50' },
        // { value: '720p-50', name: '720p-50' },
        // { value: '1080i-50', name: '1080i-50' },
        // { value: 'NTSC', name: 'NTSC (480i)' },
        // { value: '720p-60', name: '720p-60' },
        // { value: '1080i-60', name: '1080i-60' }

        // remove auto
        data.splice(0, 1);
        // remove 1080p-50
        data.splice(4, 1);
        // remove 1080p-60
        data.pop();
        break;

    // remove 576p-50 video mode
    // TODO: remove this code when MAG256 fix this video mode
    case 'MAG256':
    case 'MAG257':
        data.splice(1, 1);
        break;

    case 'MAG351':
    case 'MAG352':
    case 'MAG420':
    case 'MAG422':
    case 'MAG424':
    case 'MAG425':
    case 'MAG500':
    case 'MAG520':
    case 'MAG522':
    case 'MAG522v2':
    case 'MAG524':
    case 'MAG526':
    case 'MAG540':
    case 'IM4410WV':
    case 'IM4411':
    case 'IM4411V':
    case 'IM4411WV':
    case 'IM4412':
        data.push({value: '3840x2160p25', name: '3840x2160p-25'});
        data.push({value: '3840x2160p30', name: '3840x2160p-30'});
        data.push({value: '3840x2160p50', name: '3840x2160p-50'});
        data.push({value: '3840x2160p60', name: '3840x2160p-60'});
        break;


    case 'AndroidSTB':
    case 'emulator_stb':
        data.push({value: '3840x2160p60', title: '3840x2160p-60'});
        data.push({value: '4096x2160p60', title: '4096x2160p-60'});
        break;
}


module.exports = data;
